import { Money, formatMoney } from '@betterment/core';
import { HStack, Text, VStack } from '@betterment/samba-react';

import { type MarketScheduleType, nextMarketOpenAtLabelForPreMarket } from '../../marketSchedule';

type PreMarketHoursType = {
  currentDate: Date;
  latestPriceAmount: Money;
  marketSchedule: MarketScheduleType;
};

export const PreMarketHours = ({ currentDate, latestPriceAmount, marketSchedule }: PreMarketHoursType) => {
  const { hasNextMarketOpenLabel, nextMarketOpenLabel } = nextMarketOpenAtLabelForPreMarket({
    currentDate,
    marketSchedule,
  });

  return (
    <VStack>
      <Text color="text" variant="text100">
        Price at market close
      </Text>
      <Text variant="text400">{formatMoney(latestPriceAmount, 'default')}</Text>
      <HStack css={{ gap: 'space.50', alignItems: 'center' }}>
        {hasNextMarketOpenLabel && (
          <Text variant="text100" color="text.weak">
            {nextMarketOpenLabel}
          </Text>
        )}
      </HStack>
    </VStack>
  );
};
